import { Progress, ResponseErrorPanel, OverflowTooltip, Link } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import React from 'react';
import pluralize from 'pluralize';
import { catalogIndexRouteRef } from '../../../routes.esm.js';
import { useGetEntities } from './useGetEntities.esm.js';

const useStyles = makeStyles(
  (theme) => createStyles({
    card: {
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: theme.shadows[2],
      borderRadius: "4px",
      padding: theme.spacing(2),
      transition: `${theme.transitions.duration.standard}ms`,
      "&:hover": {
        boxShadow: theme.shadows[4]
      },
      height: "100%"
    },
    bold: {
      fontWeight: theme.typography.fontWeightBold
    },
    smallFont: {
      fontSize: theme.typography.body2.fontSize
    },
    entityTypeBox: {
      background: (props) => theme.getPageTheme({ themeId: props.type }).backgroundImage,
      color: (props) => theme.getPageTheme({ themeId: props.type }).fontColor
    }
  })
);
const EntityCountTile = ({
  counter,
  type,
  kind,
  url
}) => {
  const classes = useStyles({ type: type ?? kind });
  const rawTitle = type ?? kind;
  const isLongText = rawTitle.length > 10;
  const tile = /* @__PURE__ */ React.createElement(
    Box,
    {
      className: `${classes.card} ${classes.entityTypeBox}`,
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    /* @__PURE__ */ React.createElement(Typography, { className: classes.bold, variant: "h6" }, counter),
    /* @__PURE__ */ React.createElement(Box, { sx: { width: "100%", textAlign: "center" } }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        className: `${classes.bold} ${isLongText && classes.smallFont}`,
        variant: "h6"
      },
      /* @__PURE__ */ React.createElement(
        OverflowTooltip,
        {
          text: pluralize(rawTitle.toLocaleUpperCase("en-US"), counter)
        }
      )
    )),
    type && /* @__PURE__ */ React.createElement(Typography, { variant: "subtitle1" }, kind)
  );
  if (url) {
    return /* @__PURE__ */ React.createElement(Link, { to: url, variant: "body2" }, tile);
  }
  return tile;
};
const ComponentsGrid = ({
  className,
  entity,
  relationsType,
  relationAggregation,
  entityFilterKind,
  entityLimit = 6
}) => {
  const catalogLink = useRouteRef(catalogIndexRouteRef);
  if (!relationsType && !relationAggregation) {
    throw new Error(
      "The relationAggregation property must be set as an EntityRelationAggregation type."
    );
  }
  const { componentsWithCounters, loading, error } = useGetEntities(
    entity,
    relationAggregation ?? relationsType,
    // we can safely use the non-null assertion here because of the run-time check above
    entityFilterKind,
    entityLimit
  );
  if (loading) {
    return /* @__PURE__ */ React.createElement(Progress, null);
  } else if (error) {
    return /* @__PURE__ */ React.createElement(ResponseErrorPanel, { error });
  }
  return /* @__PURE__ */ React.createElement(Grid, { container: true, className }, componentsWithCounters?.map((c) => /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 6, md: 6, lg: 4, key: c.type ?? c.kind }, /* @__PURE__ */ React.createElement(
    EntityCountTile,
    {
      counter: c.counter,
      kind: c.kind,
      type: c.type,
      url: catalogLink && `${catalogLink()}/?${c.queryParams}`
    }
  ))));
};

export { ComponentsGrid };
//# sourceMappingURL=ComponentsGrid.esm.js.map
